module.exports = __webpack_public_path__ + "img/profess6.435e666e.png";